import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button, Checkbox } from '@smartplatform/ui';
import store from '../../store';
import './list.scss';

@observer
export default class List extends React.Component {
	@observable records = null;
	@observable isLoading = true;
	@observable showOldConvocations = false;
	settingShowOldConvocations = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.records = await store.model.Convocation.find({ order: 'id desc' });
		[this.settingShowOldConvocations] = await store.model.Config.find({ where: { code: 'showOldConvocations' }, limit: 1 });
		if (!this.settingShowOldConvocations)
			this.settingShowOldConvocations = new store.model.Config({ code: 'showOldConvocations', value: 'false' });
		this.showOldConvocations = [true, 'true'].includes(this.settingShowOldConvocations.value);
		this.isLoading = false;
	};

	toggleShowOldConvocations = () => {
		this.showOldConvocations = !this.showOldConvocations;
		this.settingShowOldConvocations.value = this.showOldConvocations;
		this.settingShowOldConvocations.save();
	};

	create = () => this.props.history.push('/admin/convocations/create');

	render() {
		if (!this.records) return '...';

		return (
			<>
				<p>Созывы</p>
				<div className="convocations-toolbar">
					<Button className="btn-primary" onClick={this.create}>
						Создать
					</Button>
					<Checkbox
						label="Показывать только текущий созыв для гостей сайта"
						value={this.showOldConvocations}
						onChange={this.toggleShowOldConvocations}
					/>
				</div>
				<Table records={this.records} rootPath="/admin">
					<Column property="name" label="Наименование" />
					<Column property="current" label="Текущий" />
				</Table>
			</>
		);
	}
}
